import * as React from 'react';
import * as S from './popover-header.styles';

export class PopoverHeader extends React.PureComponent {
    public render(): React.ReactElement {
        return <S.PopoverHeader>{this.props.children}</S.PopoverHeader>;
    }
}
